// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBa6yUgDi_Lf9wtsc2mEM_0EAF3mBrzwbQ",
  authDomain: "futurefitness-8f1f3.firebaseapp.com",
  projectId: "futurefitness-8f1f3",
  storageBucket: "futurefitness-8f1f3.firebasestorage.app",
  messagingSenderId: "909948980379",
  appId: "1:909948980379:web:fb4bb202fee445cd144a3e",
  measurementId: "G-QPKLWZ0XHC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export { db };